import { Pipe, PipeTransform } from '@angular/core';
import { CountryCodeConstant } from '../constants/country-code.constant';

@Pipe({
  name: 'govIdMask'
})

export class GovIdMaskPipe implements PipeTransform {
  transform(govId: any,countryName:any): any {
    let countryCodes = [CountryCodeConstant.BEL, CountryCodeConstant.LUX, CountryCodeConstant.NLD];
    if (govId && govId.length >= 4) {
      if(CountryCodeConstant.AUT===countryName || CountryCodeConstant.DEU===countryName){
        return govId;
      }
      let countryCode = countryCodes.filter(code => code === countryName);
      if (countryCode.length > 0) {
        let mask = govId.substring(2, govId.length - 3);
        mask = mask.replace(new RegExp("[0-9]", "g"), "X");
        return govId.substring(0, 2) + mask + govId.substr(-3);
      }
      return "XXX-XX-"+govId.substr(-4);
    }else{
      return govId;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/gov-id-mask.pipe.ts